import { Link } from '@tanstack/react-router'

import { useCurrentUser } from '@/api/auth/auth-queries'
import { MAIN_NAV } from '@/config/navigation'

export function MainNav() {
  const currentUser = useCurrentUser()
  const isAdmin = currentUser?.role === 'admin'

  return (
    <nav className="hidden items-center gap-0.5 md:flex">
      {MAIN_NAV.filter((item) => !item.adminOnly || isAdmin).map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="cursor-pointer rounded-md px-3 py-1.5 text-sm font-medium transition-colors"
          activeProps={{ className: 'text-foreground' }}
          inactiveProps={{ className: 'text-muted-foreground hover:text-foreground' }}
          activeOptions={{ exact: item.to === '/' }}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  )
}
